export type BatchWorkspaceShortcutCheatsheetBannerActions = BatchWorkspaceShortcutCheatsheetBannerClosed;

export function batchWorkspaceShortcutCheatsheetBannerClosed() {
  return {
    type: 'NEW_BATCH_WORKSPACE_SHORTCUT_CHEATSHEET_BANNER_CLOSED' as const,
  };
}
export type BatchWorkspaceShortcutCheatsheetBannerClosed = ReturnType<
  typeof batchWorkspaceShortcutCheatsheetBannerClosed
>;
